var pointTotal = {};

function bindInputs(inputs, typesToCheck) {
    inputs.each(function(x) {
        // so we don't get the CSRF token...stupid
        if (Object.keys(typesToCheck).indexOf($(this).attr('name')) != -1) {
            pointTotal[$(this).attr('name')] = 0;
            bindInput(this, typesToCheck);
        }
    });
}

function bindInput(input, typesToCheck) {
    $(input).on('keyup', function(e) {

        let regex = new RegExp(typesToCheck[$(this).attr('name')]);

        // special email check
        if ($(this).attr('name') == 'email') {
            // exists
            checkEmail($(this).val(), input);
        }

        if (regex.test($(this).val())) {
            pointTotal[$(this).attr('name')] = 1;
            $(this).next('i').show();
        } else {
            pointTotal[$(this).attr('name')] = 0;
            $(this).next('i').hide();
        }

        pointTotalCheck();
        // if at any point the point totals are full, we unlock the SUBMIT BUTTON

        // This means the keyup actually came from AutoFill
        // Chrome nonsense
        if (!e.originalEvent.cancelable) {
            $(this).trigger('blur');
            if ($(this).attr('name') == 'email') {
                // exists
                checkEmail($(this).val(), input);
            }
        }
    });
}

function checkEmail(email, input) {
    $.ajax({
        url: "/register/emailCheck",
        type: 'post',
        data: { email: email },
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
            if (response == 1) {
                pointTotal['email'] = 0;

                $(input).next('i').hide();
                $('#email-exists').show();
            } else {
                $('#email-exists').hide();
            }
            pointTotalCheck();
        }
    });
}

function pointTotalCheck() {
    let tempTotal = 0;
    for (var p in pointTotal) {
        tempTotal += pointTotal[p];
    }
    if (tempTotal == Object.keys(pointTotal).length) {
        $('#register-submit').removeAttr('disabled', '');
        $('#register-submit').removeClass('disabled');
    } else {
        $('#register-submit').attr('disabled', '');
        $('#register-submit').addClass('disabled');
    }
}
$(function() {
    var t = {
        "name": /^[\s\w-]{1,255}$/,
        "username": /^[\w-]{1,10}$/,
        "email": /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/,
        "password": /.{8,}/
    };
    bindInputs($('#registerForm').find('input'), t);
});